import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { BuyMore } from '../components/BuyMore';
import { ValueProps } from '../components/ValueProps';
import { Categories } from '../components/Categories';
import { About } from '../components/About';
import { ContactBand } from '../components/ContactBand';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-full w-full bg-white text-slate-900" data-id="element-130" data-mp="1zj8x31r61723">
      <Header data-id="element-131" data-mp="24gik6ar316mr" />
      <main data-id="element-132" data-mp="24g8wwuxf9dkr">
        <Hero data-id="element-133" data-mp="24htpwg438ogi" />
        <BuyMore data-id="element-134" data-mp="24hai3s85jgg7" />
        <ValueProps data-id="element-135" data-mp="24ivd1iydp1el" />
        <Categories data-id="element-136" data-mp="29gdaac319s6r" />
        <About data-id="element-137" data-mp="29fvgdm3ufq20" />
        <ContactBand data-id="element-138" data-mp="29fc16d5kvfro" />
      </main>
      <Footer data-id="element-139" data-mp="29ihphq6dudmc" />
    </div>;
}